import { all } from '@redux-saga/core/effects';
import {APIDuckRootSaga} from './API';
import Sinistro from './Sinistro/saga'

export default function* rootSaga(): any {
    return yield all([
        APIDuckRootSaga(),
        Sinistro()
    ]);
}